import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      marginBottom: theme.spacing(2),
    },
  })
);
